<template>
  <main :class='$style.container'>
    <price />
    <gift />
    <GroupPay />
    <Video />
    <About />
    <Contact />
  </main>
</template>

<script>
import Price from "../components/Price";
import Gift from "../components/Gift";
import GroupPay from "../components/GroupPay";
import Video from "../components/Video";
import About from "../components/About";
import Contact from "../components/Contact";
export default {
  name: "LayoutMain",
  components: { Price, Gift, GroupPay, Video, About, Contact }
};
</script>

<style lang='scss' module>
@import "../tool";
@media screen and (max-width: 750px) {
  .container {
    padding: 0 rem(12) !important;
  }
}
.container {
  padding: 0 135px;
  margin-top: 54px;
  background: #f7f5f1;
}
</style>